<template>
  <!-- 联系卡片 -->
  <UCard
    :ui="{
      root: 'bg-default/95 rounded-lg hover_elevated transition-all',
      body: ['flex flex-col gap-2'],
    }"
  >
    <div :class="['grid lg:grid-cols-2 grid-cols-1 gap-2 place-content-between']">
      <!-- 左容器 -->
      <div class="flex flex-col gap-2">
        <!-- 标题 -->
        <h4 class="lg:text-4xl text-2xl font-bold text-secondary transition_colors">
          {{ contactData.title }}
        </h4>

        <!-- 说明 -->
        <cite class="lg:text-xl text-md">
          {{ contactData.desc }}
        </cite>

        <!-- 工作时间容器 -->
        <div class="flex items-center flex-wrap gap-2">
          <!-- 工作时间 -->
          <UBadge
            :label="`${t('label.fullWeek')} ${contactData.timePeriod} UTC${contactData.timezone >= 0 ? '+' : ''}${contactData.timezone}`"
            color="primary"
            variant="subtle"
          />
          <!-- 时差提示 -->
          <UBadge :label="placeholderTimeDifference()" color="neutral" variant="subtle" />
        </div>
      </div>

      <!-- 右容器 -->
      <div
        :class="['flex justify-center items-center gap-2', 'lg:text-6xl text-xl font-bold']"
        @click="useCopy(contactData.tel)"
      >
        <UIcon name="f7:phone-circle" class="text-secondary shrink-0" />
        <!-- 标题 -->
        <VueBitsShinyText
          :text="t(contactData.tel)"
          className=""
          :speed="2"
          :delay="0"
          color="#c41230"
          shine-color="#db711a"
          :spread="120"
          :direction="'left'"
          :yoyo="false"
          :pause-on-hover="false"
        />
      </div>
    </div>
  </UCard>
</template>

<script lang="ts" setup>
  const { t } = useI18n()

  interface ContactOffice {
    title: string
    desc: string
    tel: string
    timezone: number
    timePeriod: string
  }

  const { getTimezoneDifference } = useI18nTools()

  /** 办公联络 */
  const contactData: ContactOffice = {
    title: t('placeholder.globalContact.title'),
    desc: t('placeholder.globalContact.desc'),
    tel: '+86-755-8832-3730',
    timezone: 8,
    timePeriod: '9:00-18:00',
  }

  /** 计算时差生成文字提示 */
  const placeholderTimeDifference = () => {
    const diff = getTimezoneDifference(contactData.timezone).diff
    return diff < 0
      ? t('placeholder.timeDifference.earlier', {
          diff: Math.abs(getTimezoneDifference(contactData.timezone).diff),
        })
      : diff > 0
        ? t('placeholder.timeDifference.later', {
            diff: Math.abs(getTimezoneDifference(contactData.timezone).diff),
          })
        : t('placeholder.timeDifference.same')
  }
</script>
